import PrimaryContent from './PrimaryContent.vue';
import TelemedicineContent from './TelemedicineContent.vue';
import IMIVVitaminTherapiesContent from './IMIVVitaminTherapiesContent.vue';
import PRPMicroneedlingFacialContent from './PRPMicroneedlingFacialContent.vue';
import HormoneReplacementContent from './HormoneReplacementContent.vue';
import EarLobeRepairContent from './EarLobeRepairContent.vue';
import WeightLossContent from './WeightLossContent.vue';
import FacialHarmonizationContent from './FacialHarmonizationContent.vue';
import EducationContent from './EducationContent.vue';

export const servicesContent = [
    { 
        id: 1, 
        labelPtBR: 'Cuidados Primários/Pediatria', 
        labelEn: 'Primary Care/Pediatric', 
        labelEs: 'Atención Primaria/Pediátrica',
        nameParams: 'primary-care', 
        component: PrimaryContent, 
        img: 'primary_care.png' 
    },
    { 
        id: 2, 
        labelPtBR: 'Telemedicina', 
        labelEn: 'Telemedicine', 
        labelEs: 'Telemedicina',
        nameParams: 'telemedicine', 
        component: TelemedicineContent, 
        img: 'telemedicine.png' 
    },
    { 
        id: 3, 
        labelPtBR: 'IM / IV Terapias com Vitaminas ', 
        labelEn: 'IM/IV Vitamin Therapies', 
        labelEs: 'Terapias Vitamínicas IM/IV',
        nameParams: 'im-iv-vitamin-therapies', 
        component: IMIVVitaminTherapiesContent, 
        img: 'iv_therapies.png' 
    },
    { 
        id: 4, 
        labelPtBR: 'PRP / Microagulhamento / Facial', 
        labelEn: 'PRP / Microneedling/ Facial', 
        labelEs: 'PRP / Microneedling / Facial',
        nameParams: 'prp-microneedling-facial', 
        component: PRPMicroneedlingFacialContent, 
        img: 'prp_microneedling.png' 
    },
    { 
        id: 5, 
        labelPtBR: 'Programas de Terapia Hormonal',
        labelEn: 'Hormone Therapy Programs',
        labelEs: 'Programas de Terapia Hormonal',
        nameParams: 'hormone-replacement-therapy', 
        component: HormoneReplacementContent, 
        img: 'hormone_replacement.png' 
    },
    { 
        id: 6, 
        labelPtBR: 'Reparo do Lóbulo da Orelha / Remoção de Cisto', 
        labelEn: 'Ear Lobe Repair/ Cyst Removal', 
        labelEs: 'Reparación del Lóbulo de la Oreja / Extirpación de Quistes',
        nameParams: 'ear-lobe-repair-cyst-removal', 
        component: EarLobeRepairContent, 
        img: 'ear_lobe_repair.png' 
    },
    {
        id: 7,
        labelPtBR: 'Programas de Controle de Peso',
        labelEn: 'Weight Management Programs',
        labelEs: 'Programas de Control de Peso',
        nameParams: 'weight-loss-non-surgical-fat-reduction',
        routeTo: { name: 'WeightLoss' },
        component: WeightLossContent,
        img: 'weight_loss.png'
    },
    {
        id: 9,
        labelPtBR: 'Harmonização Facial',
        labelEn: 'Facial Harmonization',
        labelEs: 'Armonización Facial',
        nameParams: 'facial-harmonization',
        component: FacialHarmonizationContent,
        img: 'facial_harmonization.png'
    },
    {
        id: 10,
        labelPtBR: 'Educação',
        labelEn: 'Education',
        labelEs: 'Educación',
        nameParams: 'education',
        component: EducationContent,
        img: 'education-classroom.png'
    }
]